/**
 * SummaryPaymentHistory Component
 * Payment history display within the Contract Summary step
 * Uses the reusable PaymentTabs component
 */

import React from 'react';
import { PaymentTabs } from '../../../../payments';

function SummaryPaymentHistory({ contract, payments, receipts, schedule }) {
  const currencyCode = contract?.currency_code || 'ZAR';

  return (
    <PaymentTabs
      contractId={contract?.id}
      schedule={schedule}
      payments={payments}
      receipts={receipts}
      currencyCode={currencyCode}
      showContractColumn={false}  // Single contract context - no need to show contract reference
      showMatchActions={false}    // View-only in contract wizard (matching done in PaymentMatching page)
      defaultTab="auto"           // Auto-select based on data: overdue > upcoming > completed
    />
  );
}

export default SummaryPaymentHistory;
